;import $ from 'jquery';
window.$ = window.jQuery = $;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/js/i18n/hu.js';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgHash from 'lightgallery/plugins/hash';
import 'jquery.scrollto';
import './vendor/ba-debug.min.js';

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // Page constructor

    // Page constructor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // Global variables

        // Responsive breakpoints
        mobileMaxWidth: 767.98,
        tabletMaxWidth: 991.98,

        // select2
        select2: {
            allowClear: true,
            containerCssClass: ':all:',
            dropdownCssClass: ':all:',
            minimumResultsForSearch: Infinity,
        },

        // lightGallery
        lightGallery: {
            download: false,
            enableDrag: false,
            plugins: [lgVideo, lgHash],
            customSlideName: true,
            autoplayFirstVideo: false,
            gotoNextSlideOnVideoEnd: false,
            subHtmlSelectorRelative: true,
            youTubePlayerParams: {
                color: '#e6007e',
                modestbranding: 1
            }
        },

        // scrollTo
        scrollTo: {
            axis: 'y',
            duration: 300,
            offset: true,
            showTabHash: true
        },

        // Modal
        modal: {
            messages: false,
            title: false
        },

        // Animation
        animation: 300,

//------------------------------------------------------------------------------------------------------------------------
    // Application

        // Set layout
        setLayout: function(){
            // Load navbar
            window.Page.loadNavbar();

            // Load galleries
            window.Page.loadGalleries();

            // Load forms
            window.Page.loadForms();

            // Load select boxes
            window.Page.loadSelectBoxes();

            // Load scrollTo
            window.Page.loadScrollTo();

            // Load popups
            window.Page.loadPopups();

            // Load modals
            window.Page.loadModals();
        },

        // Layout loaded
        layoutLoaded: function(){
            // Set navbar
            window.Page.setNavbar();
        },

        // Resize layout
        resizeLayout: function(){
            // Set navbar (10ms delay for device toolbar simulations)
            setTimeout(function(){
                window.Page.setNavbar();
            }, 10);
        },

//------------------------------------------------------------------------------------------------------------------------
    // Navbar

        // Load navbar
        loadNavbar: function(){
            // Opening navbar
            $('#navbar').on('show.bs.collapse', function(e){
                $('nav.navbar', 'header').addClass('navbar-shrink');
            });

            // Closing navbar
            $('#navbar').on('hidden.bs.collapse', function(e){
                // Set navbar
                window.Page.setNavbar();
            });
        },

        // Set navbar
        setNavbar: function(){
            var scrollTop = $(window).scrollTop();
            var minScroll = 24;

            // Shrink navbar
            if(scrollTop > minScroll || ($('.navbar-toggler', 'header').is(':visible') && $('#navbar').hasClass('show'))){
                $('nav.navbar', 'header').addClass('navbar-shrink');
            }
            else {
                $('nav.navbar', 'header').removeClass('navbar-shrink');
            }

            // Dropdowns use click on touch devices, and hover on anything else
            if(window.matchMedia('(hover: none)').matches){
                $('.dropdown-toggle', '#navbar').attr('data-bs-toggle', 'dropdown');
            }
            else {
                $('.dropdown-toggle', '#navbar').removeAttr('data-bs-toggle');
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // lightGallery

        // Load galleries
        loadGalleries: function(){
            // Load all galleries
            $('.gallery').each(function(i, target){
                window.Page.loadGallery($(target), { selector: '.item' });
            });

            // Load post video galleries
            $('.single-gallery').each(function(i, target){
                window.Page.loadGallery($(target), { selector: 'this' });
            });
        },

        // Load gallery
        loadGallery: function($target, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.lightGallery, params);

            // Gallery settings
            if(settings.dynamic){
                settings.dynamicEl = $target.data('gallery');
            }
            if($target.data('gallery-id')){
                settings.galleryId = $target.data('gallery-id');
            }

            // Load gallery
            var lg = lightGallery($target.get(0), settings);
            $target.data('lightgallery', lg);
        },

//------------------------------------------------------------------------------------------------------------------------
    // Form

        // Load forms
        loadForms: function(){
            // Load all forms
            $('.wpcf7 form').each(function(i, $form){
                // Show loader on submit
                $('button[type="submit"]', $form).on('click', function(e){
                    window.Page.showModal('loader', false);
                });

                // Toggle additional inputs
                window.Page.toggleAdditionalInputs($form);

                // Toggle additional input on change
                $('.form-group[data-show-id]', $form).each(function(j, group){
                    var id = $(group).data('showId');
                    var target = $(group).data('showTarget');
                    var value = $(group).data('showValue');
                    if(id && target && value){
                        // Check states on change
                        $(':input[name="' + id + '"]', $form).on('change', function(e){
                            window.Page.toggleAdditionalInput($form, id, target, value);
                        });
                    }
                });

                // Reset select2 and additional inputs as well
                $($form).on('reset', function(e){
                    setTimeout(function(){
                        $('select', $form).val(null).trigger('change');
                        window.Page.toggleAdditionalInputs($form);
                    }, 10);
                });
            });

            // Submission has completed
            $(document).on('wpcf7submit', function(e){
                // Hide loader (10ms delay bc some weird bugs)
                setTimeout(function(){
                    window.Page.hideModal('loader');
                }, 10);

                // Get form object
                var $input = $('input[type="hidden"][name="_wpcf7"][value="' + e.detail.contactFormId + '"]');
                var $form = $input.closest('form');
                var $successText = $('input[type="hidden"][name="successText"]', $form);
                var $attachments = $('input[type="hidden"][name="attachments"]', $form);

                // Clone confirmation modal
                var $modal = $('#modal-cf7-confirmation').clone();
                $modal.attr('id', 'modal-cf7-confirmation-' + e.detail.contactFormId);
                $modal.data('aria-labelledby', 'modal-cf7-confirmation-label-' + e.detail.contactFormId);
                $('.modal-title', $modal).attr('id', 'modal-cf7-confirmation-label-' + e.detail.contactFormId);
                $('body').append($modal);

                // Find additional text field
                var message = [], title;
                if(e.detail.status == 'mail_sent'){
                    // Messages
                    if($successText.val()){
                        message.push($successText.val());
                    }
                    if($attachments.val()){
                        message.push($attachments.val());
                    }
                    if(!message.length){
                        message.push(e.detail.apiResponse.message);
                    }
                    title = $('.modal-title', $modal).data('success');
                }
                else {
                    // Messages
                    message.push(e.detail.apiResponse.message);
                    title = $('.modal-title', $modal).data('error');
                }

                // Show confirmation modal
                window.Page.showModal('cf7-confirmation-' + e.detail.contactFormId, { title: title, messages: message });

                // Scroll to top
                window.Page.scrollToHash('#' + $form.closest('.wpcf7').attr('id'));
            });
        },

        // Toggle additional inputs
        toggleAdditionalInputs: function($form){
            // Toggle additional inputs
            $('.form-group[data-show-id]', $form).each(function(j, group){
                var id = $(group).data('showId');
                var target = $(group).data('showTarget');
                var value = $(group).data('showValue');
                if(id && target && value){
                    window.Page.toggleAdditionalInput($form, id, target, value);
                }
            });
        },

        // Toggle additional input
        toggleAdditionalInput: function($form, id, target, value){
            var $input = $(':input[name="' + id + '"][value="' + value + '"]:checked', $form);
            var $target = $(':input[id="' + target + '"]', $form).closest('p');
            if($input.val() === value){
                $target.show();
            }
            else {
                $target.hide();
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // select2

        // Load select boxes
        loadSelectBoxes: function(){
            // Load select boxes
            $('select.form-control, .gfield select').each(function(i, target){
                window.Page.loadSelect2($(target));
            });
        },

        // Load select2
        loadSelect2: function($target, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.select2, params);

            // Placeholder
            if($target.data('placeholder')){
                settings.placeholder = $target.data('placeholder');
            }

            // Load select2
            $target.select2(settings);
        },

//------------------------------------------------------------------------------------------------------------------------
    // scrollTo

        // Load scrollTo
        loadScrollTo: function(){
            // CTA
            $(document).on('click', 'a[href^="#"], a[href^="' + window.location.pathname + '#"], a[href^="' + window.location.origin + window.location.pathname + '#"]', function(e){
                e.preventDefault();

                // Prevent scrolling for dropdowns
                if($(this).hasClass('dropdown-toggle') && $(this).attr('data-bs-toggle') == 'dropdown'){
                    return false;
                }

                window.Page.scrollToHash(this.hash);
            });

            // Wait for all images before scroll to hash
            if(window.location.hash){
                window.Page.loadImages($('img:visible'), 0, (images) => {
                    window.Page.scrollToHash(window.location.hash);
                });
            }
        },

        // Load images
        loadImages: function(images, index, callback){
            if(index < images.length){
                let img = new Image();
                img.src = $(images[index]).attr('src');
                images[index].obj = img;
                images[index].obj.onload = function(){
                    window.Page.loadImages(images, ++index, callback);
                };
                images[index].obj.onerror = function(){
                    window.Page.showError('Váratlan hiba történt. (#JLI001)');
                    window.Page.loadImages(images, ++index, callback);
                };
            }
            else {
                callback(images);
            }
        },

        // Scroll to content
        scrollToHash: function(hash, params){
            if(!/^\#[0-9a-z_-]+$/gi.test(hash) || (!$(hash).is(':visible') && !$(hash).is('.tab-pane'))){
                return false;
            }

            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.scrollTo, params);

            // Target
            var $target = $(window).height() < $('.wrapper').height() ? $(window) : $('.wrapper');
            var $tab = $('[data-bs-target="' + hash + '"]');
            var $navbar = $('.navbar-collapse', 'header');
            var $sidebar = $('.sidebar-collapse', '.sidebar-nav');

            // Offset by fixed navbar's height
            if(settings.offset){
                var offset = $(hash).is('.tab-pane') ? -2 * $('header .navbar').outerHeight() : -$('header .navbar').outerHeight();
                settings.offset = { left: 0, top: 0 };
                //settings.offset.top = ($(window).width() > window.Page.tabletMaxWidth ? offset : 0);
                settings.offset.top = offset;
            }

            // Scroll to content after tab is open
            if($(hash).is('.tab-pane') && !$(hash).hasClass('show')){
                $tab.one('shown.bs.tab', function(e){
                    $target.scrollTo(hash, settings);
                });
            }
            // Scroll to content after navbar is closed
            else if($navbar.hasClass('show')){
                $navbar.one('hidden.bs.collapse', function(e){
                    $target.scrollTo(hash, settings);
                });
            }
            // Scroll to content immediately
            else {
                $target.scrollTo(hash, settings);
            }

            // Open tab if there's one
            if($(hash).is('.tab-pane') && !$(hash).hasClass('show')){
                bootstrap.Tab.getInstance($tab.get(0)).show();
            }

            // Close navbar on mobile view if open
            if($navbar.hasClass('show')){
                var bsCollapseNav = new bootstrap.Collapse($navbar.get(0), { toggle: false });
                bsCollapseNav.hide();
            }

            // Close sidebar on mobile view if open
            if($sidebar.hasClass('show')){
                var bsCollapseSide = new bootstrap.Collapse($sidebar.get(0), { toggle: false });
                bsCollapseSide.hide();
            }

            // Show hash
            if(hash != '#top' && (!$(hash).is('.tab-pane') || settings.showTabHash)){
                history.pushState({}, '', hash);
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // Popups

        // Load popups
        loadPopups: function(){
            window.Page.popupsLoaded = false;

            // Show popups only after consent is ready, because of wppopup's shitty implementation of click detection
            $(window).on('CookiebotOnConsentReady', function(e){
                window.Page.showPopups();
            });

            // Cookiebot is already ready
            if(typeof Cookiebot === 'object' && Cookiebot.hasResponse){
                window.Page.showPopups();
            }
            // Check for Cookiebot after 2s
            else {
                const checkCookiebot = setTimeout(function(){
                    // Cookiebot not loaded, show the popups
                    if(typeof Cookiebot !== 'object' && !window.Page.popupsLoaded){
                        window.Page.showPopups();
                    }
                }, 2000);
            }
        },

        // Show popups
        showPopups: function(){
            window.Page.popupsLoaded = true;

            // Show popups
            if(typeof wppopups === 'object'){
                wppopups.togglePopups(true);
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // Modals

        // Load modals
        loadModals: function(){
            // Load modals
            $('.modal').each(function(i, target){
                var modal = new bootstrap.Modal($(target).get(0));

                // Show default modals
                if($(target).attr('data-bs-show') == 'true'){
                    modal.show();
                }

                // Modal has been open
                $(target).on('shown.bs.modal', function(e){
                    // Bootstrap bugfix: losing autofocus in modals
                    $(':input[autofocus]:first', $(this)).focus();
                });
            });
        },

        // Show modal
        showModal: function(id, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Check if modal exists
            var $modal = $('#modal-' + id);
            if(!$modal.length){
                return false;
            }
            var modal = bootstrap.Modal.getOrCreateInstance($modal.get(0));

            // Substitute parameters
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).empty();
                if(typeof settings.errors !== 'undefined'){
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.errors);
                }
                else {
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.messages);
                }
            }

            // Show modal
            modal.show();
        },

        // Hide modal
        hideModal: function(id){
            // Check if modal exists
            var $modal = $('#modal-' + id);
            if(!$modal.length){
                return false;
            }
            var modal = bootstrap.Modal.getOrCreateInstance($modal.get(0));
            if(!modal){
                return false;
            }

            // Hide modal
            modal.hide();
        },

        // Show error messages
        showError: function(messages, errors){
            window.Page.showModal('error', { title: 'Hiba történt!', messages: messages, errors: errors });
        },

        // Append text array as paragraphs
        appendTextAsPs: function($target, text){
            if(!$target.length){
                return false;
            }

            // Convert variable to array
            text = typeof text !== 'undefined' ? text : [];
            if(text.constructor === String){
                text = [text];
            }
            else if(text.constructor === Array){
                text = text;
            }
            else if(typeof text === 'object'){
                var arr = [];
                $.each(text, function(i, value){
                    arr.push(value);
                });
                text = arr;
            }
            else {
                text = [];
            }

            // Append text
            $.each(text, function(i, line){
                $target.append($('<p />').html(line));
            });
        },

//------------------------------------------------------------------------------------------------------------------------

    };

//------------------------------------------------------------------------------------------------------------------------
    // Document ready

    // Document ready
    $(function(){
        // Set layout
        window.Page.setLayout();

        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window loaded

    // Window loaded
    $(window).on('load', function(e){
        // Resize layout
        window.Page.resizeLayout();

        // Layout loaded
        window.Page.layoutLoaded();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window resized or orientation changed

    // Window resized or orientation changed
    $(window).on('orientationchange resize', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window scrolled

    // Window scrolled
    $(window).on('scroll', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
